import React from "react";

export default function OfferItemInfoString({name, value}) {

    return (
        <div className="col-12">
            <b>{name + ':'}</b> <span>{value}</span>
        </div>
    )
}